import { logger } from '@lib/utils'

import type { GTMEventArgs, GTMEventBase, GTMEventPayload } from './types'

export const trackGTMEvent = ({
  event,
  conversationId,
  listing,
  details,
  messageId,
  listingAdvertiserType,
  conversationActorRole,
}: GTMEventArgs) => {
  const obj: GTMEventPayload = {
    event,
    conversationId,
    conversationListing: listing,
    conversationDetails: details,
    messageId,
    listingAdvertiserType,
    conversationActorRole,
  }

  trackGTMEventBase(obj)
}

export const trackGTMEventBase = (obj: GTMEventBase) => {
  if (document.location.hostname === 'localhost') {
    logger(`GTM-${obj.event}`, obj)
  } else {
    try {
      if (!Array.isArray(window.dataLayer)) {
        window.dataLayer = []
      }
      window.dataLayer.push(obj)
    } catch (error) {
      logger('GTM-push-failed', { event: obj.event, error })
    }
  }
}
